import React from "react";
import { Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useConfigs } from "../config-provider";
import noResult from "../assets/no_results_robot.png";
var useStyles = makeStyles({
  root: {
    lineHeight: "50px"
  }
});

var Empty = function Empty(_a) {
  var image = _a.image,
      description = _a.description,
      imageStyle = _a.imageStyle;
  var locale = useConfigs().locale;
  var classes = useStyles();
  return React.createElement(Grid, {
    container: true,
    justify: "center",
    direction: "column",
    alignItems: "center",
    className: classes.root
  }, React.createElement(Grid, null, React.createElement("img", {
    src: image || noResult,
    alt: "No Data",
    style: imageStyle
  })), description ? React.createElement(Grid, null, description) : React.createElement(React.Fragment, null, React.createElement(Grid, null, React.createElement(Typography, {
    variant: "h6",
    color: "primary"
  }, locale.Empty.noData)), React.createElement(Grid, null, React.createElement(Typography, null, locale.Empty.retry))));
};

export default Empty;